import { Col, Form, FormFeedback, Input, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap"

import PropTypes from 'prop-types'
import React, { useState } from "react"
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import * as CONSTANTS from 'common/utils/data_validations';
import { getOptionFromValueForSelectBox, getPrimaryButtonClass, getPrimaryTextClass } from "helpers/sf_utils";
import { MODE, LEAD_TYPE_IDS } from "helpers/sf_constants";
import { optionsCreditRating, optionsGender, optionsLeadEducation, optionsLeadOccupation, optionsLicenseStatus, optionsMaritalStatus, optionsRelationToPrimaryDriver } from "helpers/sf_lead_constants";
import 'react-datepicker/dist/react-datepicker.css';
import NumberFormat from "react-number-format";
import { format } from "date-fns";
import { useEffect } from "react";
import { isAutoOrMotorcycle } from "helpers/sf_leads_calls_helper";
const AddDriverModal = ({ title, show, onSaveDriverClick, onCloseClick }) => {
    const [isAutoLead, setIsAutoLead] = useState(false);
    let isPrimaryApplicant = MODE.EDIT ? show?.values?.primary_applicant : false
    const [dob, setDob] = useState(show?.mode === MODE.EDIT ? format(new Date(show?.values?.dob), 'MM-dd-yyyy') : "");

    useEffect(() => {
        if (show?.values?.dob && Date.parse(show?.values?.dob)) {
            setDob(format(new Date(show?.values?.dob), 'MM-dd-yyyy'))
        }
        setDob(show?.values?.dob ? format(new Date(show?.values?.dob), 'MM-dd-yyyy') : "")
    }, [show?.values?.dob]);

    useEffect(() => {
        isAutoOrMotorcycle(show?.values?.lead_type_id) ? setIsAutoLead(true) : setIsAutoLead(false);
    }, [show?.values]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: show?.mode === MODE.EDIT ? show?.values?.id : null,
            first_name: show?.mode === MODE.EDIT ? show?.values?.first_name : "",
            last_name: show?.mode === MODE.EDIT ? show?.values?.last_name : "",
            dob: dob,
            occupation: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsLeadOccupation, show?.values?.occupation) : null,
            relation: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsRelationToPrimaryDriver, show?.values?.relation) : null,
            marital_status: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsMaritalStatus, show?.values?.marital_status) : null,
            gender: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsGender, show?.values?.gender) : null,
            credit: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsCreditRating, show?.values?.credit) : null,
            license_status: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsLicenseStatus, show?.values?.license_status) : null,
            education: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsLeadEducation, show?.values?.education) : null,
            own_home : show?.mode === MODE.EDIT ? show?.values?.own_home : false,
            sr_22: show?.mode === MODE.EDIT ? show?.values?.sr_22 : false,
            military_service: show?.mode === MODE.EDIT ? show?.values?.military_service : false,
            bankruptcy: show?.mode === MODE.EDIT ? show?.values?.bankruptcy : false,
            primary_applicant: show?.mode === MODE.EDIT ? show?.values?.primary_applicant : false,
        },
        validationSchema: Yup.object({
            first_name: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            last_name: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            ...(show?.values?.lead_type_id !== LEAD_TYPE_IDS.COMMERCIAL && {
                dob: Yup.string()
                    .required(CONSTANTS.STR_REQUIRED_FIELD)
                    .matches(
                    /^(0?[1-9]|1[0-2])-(0?[1-9]|[1-2][0-9]|3[0-1])-(19\d{2}|20\d{2})$/,
                    'Please enter a valid date'
                ),
                occupation: Yup.object().shape({
                    label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                    value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                }),
                marital_status: Yup.object().shape({
                    label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                    value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                }),
                gender: Yup.object().shape({
                    label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                    value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                }),
                credit: Yup.object().shape({
                    label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                    value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                }),
                education: Yup.object().shape({
                    label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                    value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                }),
            })
        }),
        onSubmit: (values) => {
            onSaveDriverClick(show?.mode, {
                ...values,
                ...(show?.values?.lead_type_id !== LEAD_TYPE_IDS.COMMERCIAL && {
                    dob: format(new Date(values.dob), 'dd-MM-yyyy'),
                    relation: values?.relation?.value,
                    occupation: values?.occupation?.value,
                    marital_status: values?.marital_status?.value,
                    education: values?.education?.value,
                    credit: values?.credit?.value,
                    license_status: values?.license_status?.value,
                    gender: values?.gender?.value,
                }),
            });
        },
    });

    return (
        <Modal isOpen={show?.active} toggle={onCloseClick} centered={true} size='xl'>
            <ModalHeader>
                <div className="d-flex justify-content-center">
                    <i className={`align-self-bottom label-title bx bx-users ${getPrimaryTextClass()} me-1`}></i>
                    <span className="modal-title font-weight-semibold text-black">
                        {title}
                    </span>
                </div>
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={onCloseClick}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </ModalHeader>
            <ModalBody>
                <Form
                    onSubmit={e => {
                        e.preventDefault();
                        validation.handleSubmit()
                        return false
                    }}
                >
                    <Row className="mx-2">
                        <Col md={4} className='pe-3'>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">First Name</Label>
                                <Input
                                    type='text'
                                    className="form-control"
                                    name="first_name"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.first_name || ''}
                                    invalid={
                                        !!(validation.touched.first_name
                                            && validation.errors.first_name)
                                    }
                                />
                                {validation.touched.first_name
                                    && validation.errors.first_name ? (
                                    <FormFeedback type="invalid">
                                        {validation.errors.first_name}
                                    </FormFeedback>
                                ) : null}
                            </Col>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Last Name</Label>
                                <Input
                                    type='text'
                                    className="form-control"
                                    name="last_name"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.last_name || ''}
                                    invalid={
                                        !!(validation.touched.last_name
                                            && validation.errors.last_name)
                                    }
                                />
                                {validation.touched.last_name
                                    && validation.errors.last_name ? (
                                    <FormFeedback type="invalid">
                                        {validation.errors.last_name}
                                    </FormFeedback>
                                ) : null}
                            </Col>
                            {show?.values?.lead_type_id !== LEAD_TYPE_IDS.COMMERCIAL && (
                            <>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Date of Birth</Label>
                                <NumberFormat
                                    type="text"
                                    name="dob"
                                    format="##-##-####"
                                    mask={['M', 'M', 'D', 'D', 'Y', 'Y', 'Y', 'Y']}
                                    placeholder="MM-DD-YYYY"
                                    className="form-control"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.dob || ''}
                                    invalid={
                                        !!(validation.touched.dob
                                            && validation.errors.dob)
                                    }
                                />
                                {validation.touched.dob
                                    && validation.errors.dob ? (
                                    <span className="text-danger" type="invalid">
                                        {validation.errors.dob}
                                    </span>
                                ) : null}
                            </Col>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Marital Status</Label>
                                <Select
                                    menuPlacement="top"
                                    menuPortalTarget={document.body} 
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    options={optionsMaritalStatus}
                                    onChange={(selectedOption) => {
                                        const event = {
                                            target: {
                                                name: 'marital_status',
                                                value: selectedOption,
                                            },
                                        };
                                        validation.handleChange(event);
                                    }}
                                    onBlur={() => {
                                        validation.handleBlur({
                                            target: { name: 'marital_status' },
                                        });
                                    }}
                                    value={validation.values.marital_status || ''}
                                    invalid={
                                        !!(validation.touched.marital_status
                                            && validation.errors.marital_status)
                                    }
                                />
                                {validation.touched.marital_status
                                    && validation.errors.marital_status ? (
                                    <span className="text-danger">
                                        {CONSTANTS.STR_REQUIRED_FIELD}
                                    </span>
                                ) : null}
                            </Col>
                            { isAutoLead && 
                            <Col className="mb-3">
                            <Label className="font-weight-semibold">License Status</Label>
                                <Select
                                    menuPlacement="top"
                                    menuPortalTarget={document.body} 
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    options={optionsLicenseStatus}
                                    onChange={(selectedOption) => {
                                        const event = {
                                            target: {
                                                name: 'license_status',
                                                value: selectedOption,
                                            },
                                        };
                                        validation.handleChange(event);
                                    }}
                                    onBlur={() => {
                                        validation.handleBlur({
                                            target: { name: 'license_status' },
                                        });
                                    }}
                                    value={validation.values.license_status || ''}
                                    invalid={
                                        !!(validation.touched.license_status
                                            && validation.errors.license_status)
                                    }
                                />
                                {validation.touched.license_status
                                    && validation.errors.license_status ? (
                                    <span className="text-danger">
                                        {CONSTANTS.STR_REQUIRED_FIELD}
                                    </span>
                                ) : null}
                            </Col>
                            }
                            </>
                            )}
                        </Col>
                        {show?.values?.lead_type_id !== LEAD_TYPE_IDS.COMMERCIAL && (
                        <>
                        <Col md={4} className='pe-3'>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Education</Label>
                                <Select
                                    menuPortalTarget={document.body} 
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    options={optionsLeadEducation}
                                    onChange={(selectedOption) => {
                                        const event = {
                                            target: {
                                                name: 'education',
                                                value: selectedOption,
                                            },
                                        };
                                        validation.handleChange(event);
                                    }}
                                    onBlur={() => {
                                        validation.handleBlur({
                                            target: { name: 'education' },
                                        });
                                    }}
                                    value={validation.values.education || ''}
                                    invalid={
                                        !!(validation.touched.education
                                            && validation.errors.education)
                                    }
                                />
                                {validation.touched.education
                                    && validation.errors.education ? (
                                    <span className="text-danger">
                                        {CONSTANTS.STR_REQUIRED_FIELD}
                                    </span>
                                ) : null}
                            </Col>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Occupation</Label>
                                <Select
                                    menuPortalTarget={document.body} 
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    options={optionsLeadOccupation}
                                    onChange={(selectedOption) => {
                                        const event = {
                                            target: {
                                                name: 'occupation',
                                                value: selectedOption,
                                            },
                                        };
                                        validation.handleChange(event);
                                    }}
                                    onBlur={() => {
                                        validation.handleBlur({
                                            target: { name: 'occupation' },
                                        });
                                    }}
                                    value={validation.values.occupation || ''}
                                    invalid={
                                        !!(validation.touched.occupation
                                            && validation.errors.occupation)
                                    }
                                />
                                {validation.touched.occupation
                                    && validation.errors.occupation ? (
                                    <span className="text-danger">
                                        {CONSTANTS.STR_REQUIRED_FIELD}
                                    </span>
                                ) : null}
                            </Col>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Gender</Label>
                                <Select
                                    menuPortalTarget={document.body} 
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    options={optionsGender}
                                    onChange={(selectedOption) => {
                                        const event = {
                                            target: {
                                                name: 'gender',
                                                value: selectedOption,
                                            },
                                        };
                                        validation.handleChange(event);
                                    }}
                                    onBlur={() => {
                                        validation.handleBlur({
                                            target: { name: 'gender' },
                                        });
                                    }}
                                    value={validation.values.gender || null}
                                    invalid={
                                        !!(validation.touched.gender
                                            && validation.errors.gender)
                                    }
                                />
                                {validation.touched.gender
                                    && validation.errors.gender ? (
                                    <span className="text-danger">
                                        {CONSTANTS.STR_REQUIRED_FIELD}
                                    </span>
                                ) : null}
                            </Col>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Credit Rating</Label>
                                <Select
                                    menuPortalTarget={document.body} 
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    options={optionsCreditRating}
                                    onChange={(selectedOption) => {
                                        const event = {
                                            target: {
                                                name: 'credit',
                                                value: selectedOption,
                                            },
                                        };
                                        validation.handleChange(event);
                                    }}
                                    onBlur={() => {
                                        validation.handleBlur({
                                            target: { name: 'credit' },
                                        });
                                    }}
                                    value={validation.values.credit || ''}
                                    invalid={
                                        !!(validation.touched.credit
                                            && validation.errors.credit)
                                    }
                                />
                                {validation.touched.credit
                                    && validation.errors.credit ? (
                                    <span className="text-danger">
                                        {CONSTANTS.STR_REQUIRED_FIELD}
                                    </span>
                                ) : null}
                            </Col>
                            { isAutoLead && 
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Relation to Primary Driver</Label>
                                <Select
                                    menuPortalTarget={document.body} 
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    maxMenuHeight="200px"
                                    options={optionsRelationToPrimaryDriver}
                                    onChange={(selectedOption) => {
                                        const event = {
                                            target: {
                                                name: 'relation',
                                                value: selectedOption,
                                            },
                                        };
                                        validation.handleChange(event);
                                    }}
                                    onBlur={() => {
                                        validation.handleBlur({
                                            target: { name: 'relation' },
                                        });
                                    }}
                                    value={validation.values.relation || null}
                                    invalid={
                                        !!(validation.touched.relation
                                            && validation.errors.relation)
                                    }
                                />
                                {validation.touched.relation
                                    && validation.errors.relation ? (
                                    <span className="text-danger">
                                        {CONSTANTS.STR_REQUIRED_FIELD}
                                    </span>
                                ) : null}
                            </Col>
                            }
                        </Col>
                        <Col md={4} className='pe-3'>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Military</Label>
                                <ul className="nav nav-pills d-flex gap-3 mb-3" id="pills-tab" role="tablist">
                                    <li className="nav-item">
                                        <button
                                            className={`btn sf-btn text-black ${validation?.values?.military_service === true ? "active" : ""}`}
                                            data-bs-toggle="pill"
                                            type="button"
                                            role="tab"
                                            name="military_service"
                                            value={true}
                                            onClick={(e) => {
                                                const event = {
                                                    ...e,
                                                    target: {
                                                        value: true,
                                                        name: "military_service",
                                                    },
                                                }
                                                validation.handleChange(event)
                                            }}
                                            id="driver_modal_military_male"
                                        >
                                            Yes
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            className={`btn sf-btn text-black ${validation?.values?.military_service === false ? "active" : ""}`}
                                            data-bs-toggle="pill"
                                            type="button"
                                            role="tab"
                                            name="military_service"
                                            value={false}
                                            onClick={(e) => {
                                                const event = {
                                                    ...e,
                                                    target: {
                                                        value: false,
                                                        name: "military_service",
                                                    },
                                                }
                                                validation.handleChange(event)
                                            }}
                                            id="driver_modal_military_female"
                                        >
                                            No
                                        </button>
                                    </li>
                                </ul>
                            </Col>
                            {isPrimaryApplicant == true ? 
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Homeowner</Label>
                                <ul className="nav nav-pills d-flex gap-3 mb-3" id="pills-tab" role="tablist">
                                    <li className="nav-item">
                                        <button
                                            className={`btn sf-btn text-black ${validation?.values?.own_home === true ? "active" : ""}`}
                                            data-bs-toggle="pill"
                                            type="button"
                                            role="tab"
                                            name="own_home"
                                            value={true}
                                            onClick={(e) => {
                                                const event = {
                                                    ...e,
                                                    target: {
                                                        value: true,
                                                        name: "own_home",
                                                    },
                                                }
                                                validation.handleChange(event)
                                            }}
                                            id="driver_modal_home_owner_male"
                                        >
                                            Yes
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            className={`btn sf-btn text-black ${validation?.values?.own_home === false ? "active" : ""}`}
                                            data-bs-toggle="pill"
                                            type="button"
                                            role="tab"
                                            name="own_home"
                                            value={false}
                                            onClick={(e) => {
                                                const event = {
                                                    ...e,
                                                    target: {
                                                        value: false,
                                                        name: "own_home",
                                                    },
                                                }
                                                validation.handleChange(event)
                                            }}
                                            id="driver_modal_home_owner_female"
                                        >
                                            No
                                        </button>
                                    </li>
                                </ul>
                            </Col>
                            :
                            ''
                            }
                            {isPrimaryApplicant == true ? 
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">SR22</Label>
                                <ul className="nav nav-pills d-flex gap-3 mb-3" id="pills-tab" role="tablist">
                                    <li className="nav-item">
                                        <button
                                            className={`btn sf-btn text-black ${validation?.values?.sr_22 === true ? "active" : ""}`}
                                            data-bs-toggle="pill"
                                            type="button"
                                            role="tab"
                                            name="sr_22"
                                            value={true}
                                            onClick={(e) => {
                                                const event = {
                                                    ...e,
                                                    target: {
                                                        value: true,
                                                        name: "sr_22",
                                                    },
                                                }
                                                validation.handleChange(event)
                                            }}
                                            id="driver_modal_sr22_male"
                                        >
                                            Yes
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            className={`btn sf-btn text-black ${validation?.values?.sr_22 === false ? "active" : ""}`}
                                            data-bs-toggle="pill"
                                            type="button"
                                            role="tab"
                                            name="sr_22"
                                            value={false}
                                            onClick={(e) => {
                                                const event = {
                                                    ...e,
                                                    target: {
                                                        value: false,
                                                        name: "sr_22",
                                                    },
                                                }
                                                validation.handleChange(event)
                                            }}
                                            id="driver_modal_sr22_female"
                                        >
                                            No
                                        </button>
                                    </li>
                                </ul>
                            </Col>
                            :
                            ''
                            }
                            {isPrimaryApplicant == true ? 
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Bankruptcy</Label>
                                <ul className="nav nav-pills d-flex gap-3 mb-3" id="pills-tab" role="tablist">
                                    <li className="nav-item">
                                        <button
                                            className={`btn sf-btn text-black ${validation?.values?.bankruptcy === true ? "active" : ""}`}
                                            data-bs-toggle="pill"
                                            type="button"
                                            role="tab"
                                            name="bankruptcy"
                                            value={true}
                                            onClick={(e) => {
                                                const event = {
                                                    ...e,
                                                    target: {
                                                        value: true,
                                                        name: "bankruptcy",
                                                    },
                                                }
                                                validation.handleChange(event)
                                            }}
                                            id="driver_modal_bankruptcy_male"
                                        >
                                            Yes
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            className={`btn sf-btn text-black ${validation?.values?.bankruptcy === false ? "active" : ""}`}
                                            data-bs-toggle="pill"
                                            type="button"
                                            role="tab"
                                            name="bankruptcy"
                                            value={false}
                                            onClick={(e) => {
                                                const event = {
                                                    ...e,
                                                    target: {
                                                        value: false,
                                                        name: "bankruptcy",
                                                    },
                                                }
                                                validation.handleChange(event)
                                            }}
                                            id="driver_modal_bankruptcy_female"
                                        >
                                            No
                                        </button>
                                    </li>
                                </ul>
                            </Col>
                            : 
                            ''}
                        </Col>
                        </>
                        )}
                    </Row>
                    <Row>
                        <Col md="12" lg="12">
                            <div className="text-end mt-3">
                                <button
                                    type="submit"
                                    className={`btn ${getPrimaryButtonClass()} ms-2`}
                                    name="submit"
                                >
                                    Save
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-light ms-2"
                                    onClick={onCloseClick}
                                >
                                    Cancel
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </ModalBody>
        </Modal>
    )
}

AddDriverModal.propTypes = {
    onCloseClick: PropTypes.func,
    onSaveDriverClick: PropTypes.func,
    show: PropTypes.any,
    title: PropTypes.any,
}

export default AddDriverModal;

